import { styled } from 'styled-components';

export const LoaderInlineWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.sizing.small};
  align-items: center;
  animation: fadeIn ${({ theme }) => theme.animation.duration.default}
    ${({ theme }) => theme.animation.easing.moving};
  z-index: 2;

  > div {
    z-index: 2;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
LoaderInlineWrapper.displayName = 'LoaderInlineWrapper';

export const LoaderInlineLabel = styled.div`
  z-index: 2;
  ${({ theme }) => theme.typography.bodySmall}
`;
LoaderInlineLabel.displayName = 'LoaderInlineLabel';
